import * as actions_admin from 'actions/admin-actions';
import * as toolbox from 'components/common/toolbox';
import Authorize from 'components/common/authorize';
import InvoicesTasks from './admin-groups/invoices-tasks';
import MyWorkOrders from './my-tasks';
import QuotesTasks from './admin-groups/quotes-tasks';
import React, { useEffect, useState } from 'react';
import ResultsMyWorkOrders from 'components/dashboard/results/results-my-work-orders';
import ServiceRequestsTasks from './admin-groups/service-requests-tasks';
import Swal from 'sweetalert2';
import TasksCheckin from 'components/time-clock/tasks-checkin';
import WorkOrdersTasks from './admin-groups/work-orders-tasks';
import { PERMISSIONS } from 'components/constants';
import { numPanels } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';

export default function DashboardLayout(props) {

	const seg = 3;
	const params = useParams();
	const history = useHistory();
	const routeLocation = useLocation();

	const [currenWidget, setCurrentWidget] = useState(false);

	// Show permanent deprecation notice - restricts app access
	useEffect(() => {
		Swal.fire({
			title: 'App Deprecation Notice',
			html: '<p>This current version of the app is deprecated and is being replaced by a new mobile app.</p><p>Check back for more information.</p>',
			icon: 'warning',
			showConfirmButton: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			backdrop: true,
		});
	}, []);

	useEffect(() => {
        setCurrentWidget(params.widget_id);
    });

	useEffect(() => {
		if (!params.form) {
			var location = toolbox.modifyPath(routeLocation?.pathname, seg, `${params.widget_id}/0/overview/tab`, seg+3);
			history.replace({ pathname: location });
		}
	}, [params.widget_id, params.form]);
	
	const handleClick = (widget_id) => {
		let segments = routeLocation.pathname.split('/').length;
        let num = (segments >= 12) ? -2 : (segments >= 10) ? -1 : 0;
		if (num) history.go(num);

		setTimeout(() => {
			let id = (widget_id !== currenWidget) ? widget_id : 'dashboard';
			var location = toolbox.modifyPath(routeLocation?.pathname, seg, `${id}/0/overview/tab`, seg+3);
			history.replace({ pathname: location });
		}, 50);
	}

	const toggleAnalytics = () => {
		let location = toolbox.modifyPath(routeLocation?.pathname, seg+1, "overview/mobile");
		history.push({ pathname: location });
	}

    return (
		<>
			<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_EDIT.key] }>
				{/* Show Currently Checked In */}
				<ResultsMyWorkOrders source="checkedIn" />
				<div className="middleOfLine text-muted mt-3">
					<h1 className="mx-2 mt-2">My Dashboard</h1>
				</div>
				<TasksCheckin source="checkedIn" /> 
				<MyWorkOrders handleClick={ handleClick } />
			</Authorize>

			{/* <button onClick={ () => actions_admin.createNotification() }>CREATE NOTIFICATION</button> */}
			{/* <button onClick={ () => actions_admin.updateAttachments() }>UPDATE ATTACHMENTS</button> */}
			{/* <button onClick={ () => actions_admin.callCloudFunction() }>CALL CLOUD FUNCTION</button> */}


			{/* ADDITIONAL WIDGETS BASED ON PERMISSION -------------------------------------------------- */}

			<Authorize permKeys={[
				PERMISSIONS.SERVICE_REQUESTS_VIEW.key,
				PERMISSIONS.WORK_ORDERS_VIEW.key,
				PERMISSIONS.QUOTES_VIEW.key,
			]}>
				<div className="middleOfLine text-muted mt-4 mb-n2">
					<h1 className="mx-2 mt-2">Company Dashboard</h1>
				</div>
			</Authorize>

			{ numPanels(1) &&
				<button className="btn btn-default btn-lg btn-block my-2 p-3 d-flex align-items-center justify-content-center text-muted" onClick={ toggleAnalytics } style={{ fontSize: '16px' }}>
					<i className="fa-duotone fa-solid fa-chart-pie fa-2x mr-3"></i> View Dashboard Overview
				</button>
			}

			<Authorize perm={ PERMISSIONS.SERVICE_REQUESTS_VIEW }>
				<h2 className="col-12 ml-2">Service Requests</h2>
				<ServiceRequestsTasks handleClick={ handleClick } />
			</Authorize>

			<Authorize perm={ PERMISSIONS.WORK_ORDERS_VIEW }>
				<h2 className="col-12 ml-2">Work Orders</h2>
				<WorkOrdersTasks handleClick={ handleClick } />
			</Authorize>

			<Authorize feature={'generate_quotes'} perm={ PERMISSIONS.QUOTES_VIEW }>
				<h2 className="col-12 ml-2">Quotes</h2>
				<QuotesTasks handleClick={ handleClick } />
			</Authorize>

			<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
				<h2 className="col-12 ml-2">Invoices</h2>
				<InvoicesTasks handleClick={ handleClick } />
			</Authorize>

			<div className="mb-5"></div>
		</>
	);
};
